import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/codebuild/output/src264020964/src/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/article/article-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/global/create-an-account.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/global/newsletter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/global/top-sportsbooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/news/article.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/news/recent-news.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/primitives/button.tsx");
